export default __webpack_public_path__ + "static/media/Group9271.e9a92784.svg";